import React from 'react'

function Inputtt({placeholder, label, type, onChange, value, name}) {
  return (
    <div className='my-2'>
      <label className='block mb-3 text-back-color2'>{label}</label>
      <input
        className='w-full bg-white outline-0 border border-[#343373] p-3 rounded-lg transition-all duration-300 focus:ring-2 focus:ring-[#343373]/30 focus:border-[#343373] focus:shadow-lg'
        placeholder={placeholder}
        type={type}
        name={name}
        required
      />
    </div>
  )
}

export default Inputtt
